import { useCallback, useState } from "react"
import { Grid, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { StandardButton } from "../buttons/StandardButton"
import { StandardDialog } from "./StandardDialog"

const useStyles = makeStyles()(() => ({
    container: {
        padding: "0 2rem 2rem 2rem",
    },
}))

type LockedDialogState = Readonly<{
    open: boolean
    title: string
    body: string
}>

const defaultLockedDialogState: LockedDialogState = {
    open: false,
    title: "",
    body: "",
}

export function useLockedDialogState() {
    const [lockedDialog, setLockedDialog] = useState<LockedDialogState>(defaultLockedDialogState)

    const openLockedDialog = useCallback((args: Readonly<Omit<LockedDialogState, "open">>) => {
        setLockedDialog({
            open: true,
            ...args,
        })
    }, [])

    const closeLockedDialog = useCallback(() => {
        setLockedDialog(defaultLockedDialogState)
    }, [])

    return {
        lockedDialog,
        openLockedDialog,
        closeLockedDialog,
    }
}

type LockedDialogProps = Readonly<{
    dialogDetails: LockedDialogState
    onClose: () => void
}>

export function LockedDialog({ dialogDetails, onClose }: LockedDialogProps) {
    const { classes } = useStyles()
    const { open, title, body } = dialogDetails

    return (
        <StandardDialog open={open} onClose={onClose} maxWidthProp="sm" dialogTitle={title}>
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                gap="2rem"
                className={classes.container}
            >
                <Typography variant="body1" textAlign="center">
                    {body}
                </Typography>
                <LocalizedStrict id="floating-action-button">
                    <StandardButton fullWidth={false} onClick={onClose}>
                        Close
                    </StandardButton>
                </LocalizedStrict>
            </Grid>
        </StandardDialog>
    )
}
